import Act from "../actions";
import moduleSetting from "../../config/config.module";
import { isElectronApp } from "../../common/utils/electronAppHelper";
import { LIMIT_SETTING } from "../../config/config.limit";

const initState = {
  message: {
    open: false,
    content: "",
  },
  // todo: 若是 electron app, 讀取 moduleSetting, 若是 web app, 讀取 firebase 設定
  moduleSetting: isElectronApp() ? moduleSetting : null, // 模組設定
  limitSetting: isElectronApp() ? LIMIT_SETTING : LIMIT_SETTING, // 模組 limit
  loader: {
    open: false,
    // value: 20, // loader 顯示的百分比
  },
};

const MESSAGE_TYPE = {
  success: "success",
  error: "error",
  info: "info",
  warning: "warning",
};

const commonReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.COMMON_SET_MESSAGE:
      return { ...state, message: { ...action.payload } };
    case Act.COMMON_SET_SUCCESS_MESSAGE:
      return {
        ...state,
        message: { ...action.payload, type: MESSAGE_TYPE.success },
      };
    case Act.COMMON_SET_INFO_MESSAGE:
      return {
        ...state,
        message: { ...action.payload, type: MESSAGE_TYPE.info },
      };
    case Act.COMMON_SET_WARNING_MESSAGE:
      return {
        ...state,
        message: { ...action.payload, type: MESSAGE_TYPE.warning },
      };
    case Act.COMMON_SET_ERROR_MESSAGE:
      return {
        ...state,
        message: { ...action.payload, type: MESSAGE_TYPE.error },
      };
    case Act.COMMON_CLEAR_MESSAGE:
      return { ...state, message: initState.message };
    case Act.COMMON_MODULE_SETTING:
      return { ...state, moduleSetting: action.payload };
    case Act.COMMON_SET_LOADER:
      return { ...state, loader: action.payload };
    default:
      return state;
  }
};

export default commonReducer;
